// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.premanft",
    name: "PREMA Wallet",
    homepage: "https://premanft.com/",
    image_id: "6487869b-1165-4f30-aa3a-115665be8300",
    app: {
        browser: "https://premanft.com/",
        ios: "https://apps.apple.com/us/app/prema%E3%82%A6%E3%82%A9%E3%83%AC%E3%83%83%E3%83%88-%E3%83%9E%E3%83%AB%E3%83%81%E3%83%81%E3%82%A7%E3%83%BC%E3%83%B3%E3%82%A2%E3%83%97%E3%83%AA/id1603556315",
        android: "https://play.google.com/store/apps/details?id=co.jp.xcreation.premawallet",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "premawallet://",
        universal: "https://premanft.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map